<template>
  <Dropdown :transfer="true" trigger="click" @on-click="actionTrigger">
    <ComputeQuota ref="ComputeQuota"></ComputeQuota>
    <NetworkQuota ref="NetworkQuota"></NetworkQuota>
    <StorageQuota ref="StorageQuota"></StorageQuota>
    <ProjectMember ref="ProjectMember"></ProjectMember>
    <Button type="dashed" size="small">
      更多操作
      <Icon type="ios-arrow-down"></Icon>
    </Button>
    <DropdownMenu slot="list">
      <DropdownItem name="memberMange">管理成员</DropdownItem>
      <DropdownItem name="computeQuota">计算资源配额</DropdownItem>
      <DropdownItem name="networkQuota">网络资源配额</DropdownItem>
      <DropdownItem name="storageQuota">存储资源配额</DropdownItem>
      <DropdownItem name="deleteProject"><span :style="{color: 'red'}">删除租户</span></DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { deletePrivateCloudProject } from '@/api/private-cloud/project'
import ComputeQuota from './compute-quota'
import NetworkQuota from './network-quota'
import StorageQuota from './storage-quota'
import ProjectMember from './project-member'

export default {
  name: 'ActionMenu',
  props: {
    project: Object,
    users: Array,
    roles: Array
  },
  components: {
    ComputeQuota,
    NetworkQuota,
    ProjectMember,
    StorageQuota
  },
  data () {
    return {

    }
  },
  methods: {
    actionTrigger (name) {
      switch (name) {
        case 'memberMange':
          this.$refs.ProjectMember.getRoleAssignments(this.project, this.users, this.roles)
          break
        case 'computeQuota':
          this.$refs.ComputeQuota.getComputeQuota(this.project)
          break
        case 'networkQuota':
          this.$refs.NetworkQuota.getNetworkQuota(this.project)
          break
        case 'storageQuota':
          this.$refs.StorageQuota.getStorageQuota(this.project)
          break
        case 'deleteProject':
          this.deleteProject()
          break
      }
    },
    deleteProject () {
      this.$Modal.confirm({
        title: '删除',
        content: '确定要删除租户「' + this.project.name + '」吗？',
        onOk: () => {
          deletePrivateCloudProject(this.project.id).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.$emit('callback')
          }).catch(res => {
            if (res.response) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.response.data
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
